export default class RNRestart {
  static Restart() {
    location.reload();
  }
}
